import React from 'react';

const New = () => {
    return (
        <div className='new'>
            <h2>New page</h2>
        </div>
    );
};

export default New;